<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Subscribe</h1>
        </template>
        
        <div v-if="loaded">
            <best-available-offer v-if="endpoint === '/api/subscription'"></best-available-offer>
            
            <p>You're subscribing to the plan: <strong>{{ name }}</strong> for <strong>{{ price }}</strong>.</p>
            
            <div class="my-4 w-full">
                <card-input :stripe-key="stripeKey" :client-secret="clientSecret" ref="card"></card-input>
            </div>

            <div class="my-4 w-full">
                <label for="coupon" class="font-bold">Do you have any coupon code?</label>
                <input type="text" name="coupon" id="coupon" class="my-1 border border-gray-dark border-b-2 p-2 rounded w-full uppercase" placeholder="COUPON" v-model="coupon">
                <p class="text-destructive" v-if="errors.coupon && errors.coupon.length > 0">{{ errors.coupon[0] }}</p>
            </div>

            <div class="mt-4 w-full">
                <p class="text-destructive" v-if="errors.general && errors.general.length > 0">{{ errors.general[0] }}</p>
            </div>
        </div>
        <div v-else>
            <loading />
        </div>

        <template v-slot:footer v-if="loaded">
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                :loading="loading"
                state="Subscribing..."
                @click.native="submit"
            >
                Confirm
            </progressable-button>
            <button class="ml-2 py-2 px-4 rounded-md bg-primary-lightest" @click="close">Cancel</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        plan: {
            type: String,
            required: true,
        },
        endpoint: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loaded       : false,
            price        : 0,
            stripeKey    : null,
            clientSecret : null,
            coupon       : '',
            loading      : false,
            errors       : {},
            paymentMethod: null,
            hasSponsor   : window.User.sponsor,
        }
    },
    mounted() {
        axios.post(`${this.endpoint}/intents`, {
            plan: this.plan,
        })
        .then(response => {
            this.stripeKey = response.data.data.key;
            this.clientSecret = response.data.data.intent;
            this.price = response.data.data.price,
            this.loaded = true;
        })
        .catch(err => {
            console.error(err);
        });
    },
    methods: {
        async submit() {
            this.errors = {};
            this.loading = true;
            
            // if the card is not tokenized already, we'll tokenize it
            if (this.paymentMethod === null) {
                const paymentMethod = await this.$refs.card.tokenize();
                // if any error tokenizing, we'll bail out
                if (!paymentMethod) {
                    this.loading = false;
                    return;
                }
                this.paymentMethod = paymentMethod;
            }
            
            axios.put(this.endpoint, {
                plan          : this.plan,
                coupon        : this.coupon,
                payment_method: this.paymentMethod,
            })
            .then(response => {
                this.$emit('resolve', response);
            })
            .catch(err => {
                this.errors = err.response.data.errors;
                this.loading = false;
                console.error(err);
            }).then(() => {
                this.loading = false;
            });
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>